/** Org Service — helpers de formato sin JSX (aparte de org-ui.tsx por react-refresh). El catálogo de soluciones es ORG_SOLUTIONS (shared), nunca una lista local. */
import { solutionBySlug } from '../../../../shared/org-rules';

export function solutionName(slug: string | null | undefined): string {
  if (!slug) return '';
  return solutionBySlug(slug)?.name ?? slug;
}
